export const selectorTypes = {
  text: 1,
  radiobox: 2,
  checkbox: 3
}